// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/pursuit_read.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
/**
 * @generated from enum mono.projectdata.v1.ThreadGroup
 */ export var ThreadGroup = /*#__PURE__*/ function(ThreadGroup) {
    /**
   * @generated from enum value: THREAD_GROUP_UNSPECIFIED = 0;
   */ ThreadGroup[ThreadGroup["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
   * @generated from enum value: THREAD_GROUP_MARKET = 1;
   */ ThreadGroup[ThreadGroup["MARKET"] = 1] = "MARKET";
    /**
   * @generated from enum value: THREAD_GROUP_CUSTOMER = 2;
   */ ThreadGroup[ThreadGroup["CUSTOMER"] = 2] = "CUSTOMER";
    /**
   * @generated from enum value: THREAD_GROUP_SHAPING = 3;
   */ ThreadGroup[ThreadGroup["SHAPING"] = 3] = "SHAPING";
    /**
   * @generated from enum value: THREAD_GROUP_DECISIONS = 4;
   */ ThreadGroup[ThreadGroup["DECISIONS"] = 4] = "DECISIONS";
    /**
   * WRT contract (30-writing-workspace.md, RFI Home signals): govcon.rfi_signals events use group "workspaces".
   * The FE "Market" chip requests [MARKET, WORKSPACES]; there is no separate chip.
   *
   * @generated from enum value: THREAD_GROUP_WORKSPACES = 5;
   */ ThreadGroup[ThreadGroup["WORKSPACES"] = 5] = "WORKSPACES";
    return ThreadGroup;
}({});
// Retrieve enum metadata with: proto3.getEnumType(ThreadGroup)
proto3.util.setEnumType(ThreadGroup, "mono.projectdata.v1.ThreadGroup", [
    {
        no: 0,
        name: "THREAD_GROUP_UNSPECIFIED"
    },
    {
        no: 1,
        name: "THREAD_GROUP_MARKET"
    },
    {
        no: 2,
        name: "THREAD_GROUP_CUSTOMER"
    },
    {
        no: 3,
        name: "THREAD_GROUP_SHAPING"
    },
    {
        no: 4,
        name: "THREAD_GROUP_DECISIONS"
    },
    {
        no: 5,
        name: "THREAD_GROUP_WORKSPACES"
    }
]);
/**
 * One on-glass label. The ONLY pursuit vocabulary the UI may render (09:623 "thickness + labels").
 * key ∈ parked | closed | merged | legacy_no_bid | legacy_converted | shaping | qualifying | pursuing | watching |
 *       rfi_open | proposal_open | recompete
 * tone ∈ neutral | violet | warning | info | success  (maps 1:1 to SpecraBadge variant)
 *
 * @generated from message mono.projectdata.v1.PursuitLabel
 */ export class PursuitLabel extends Message {
    static fromBinary(bytes, options) {
        return new PursuitLabel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitLabel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitLabel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitLabel, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: string tone = 3;
   */ _define_property(this, "tone", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitLabel, "runtime", proto3);
_define_property(PursuitLabel, "typeName", "mono.projectdata.v1.PursuitLabel");
_define_property(PursuitLabel, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "tone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * A link to another record. kind ∈ pursuit | program | opportunity | notice | landscape | person | company |
 * government_org | vehicle | rfi_response | proposal | library_item | registry_contract | seat
 *
 * @generated from message mono.projectdata.v1.EntityRef
 */ export class EntityRef extends Message {
    static fromBinary(bytes, options) {
        return new EntityRef().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EntityRef().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EntityRef().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EntityRef, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * built server-side from §3.2 route table; empty when no route exists
   *
   * @generated from field: string href = 4;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(EntityRef, "runtime", proto3);
_define_property(EntityRef, "typeName", "mono.projectdata.v1.EntityRef");
_define_property(EntityRef, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitHolder
 */ export class PursuitHolder extends Message {
    static fromBinary(bytes, options) {
        return new PursuitHolder().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitHolder().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitHolder().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitHolder, a, b);
    }
    constructor(data){
        super(), /**
   * us | competitor | new_requirement | unknown
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * "Us" | "<company name>" | "New" | ""
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitHolder, "runtime", proto3);
_define_property(PursuitHolder, "typeName", "mono.projectdata.v1.PursuitHolder");
_define_property(PursuitHolder, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitOwner
 */ export class PursuitOwner extends Message {
    static fromBinary(bytes, options) {
        return new PursuitOwner().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitOwner().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitOwner().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitOwner, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string user_id = 1;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitOwner, "runtime", proto3);
_define_property(PursuitOwner, "typeName", "mono.projectdata.v1.PursuitOwner");
_define_property(PursuitOwner, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitsRequest
 */ export class ListPursuitsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * live | parked | closed (default live). live = lifecycle 'active' AND not merged AND NOT legacy_closed;
   * closed = lifecycle 'closed' OR merged OR legacy_closed (§3.1 rule L).
   *
   * @generated from field: string lifecycle = 1;
   */ _define_property(this, "lifecycle", ""), /**
   * default 50, max 200
   *
   * @generated from field: int32 page_size = 2;
   */ _define_property(this, "pageSize", 0), /**
   * opaque keyset token (updated_at DESC, id DESC)
   *
   * @generated from field: string page_token = 3;
   */ _define_property(this, "pageToken", ""), /**
   * case-insensitive substring on name; empty = all
   *
   * @generated from field: string search = 4;
   */ _define_property(this, "search", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitsRequest, "runtime", proto3);
_define_property(ListPursuitsRequest, "typeName", "mono.projectdata.v1.ListPursuitsRequest");
_define_property(ListPursuitsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "search",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitRow
 */ export class PursuitRow extends Message {
    static fromBinary(bytes, options) {
        return new PursuitRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * /capture/{id}
   *
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * active | parked | closed (raw column; legacy no-bid/converted rows are 'active' — use labels)
   *
   * @generated from field: string lifecycle = 4;
   */ _define_property(this, "lifecycle", ""), /**
   * shaping | qualifying | pursuing | unknown
   *
   * @generated from field: string business_phase = 5;
   */ _define_property(this, "businessPhase", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitLabel labels = 6;
   */ _define_property(this, "labels", []), /**
   * government_org (opportunity context customer, else capture_projects.customer_org_id)
   *
   * @generated from field: mono.projectdata.v1.EntityRef customer = 7;
   */ _define_property(this, "customer", void 0), /**
   * government_org from opportunities.contracting_org_id; empty when none
   *
   * @generated from field: mono.projectdata.v1.EntityRef contracting_office = 8;
   */ _define_property(this, "contractingOffice", void 0), /**
   * vehicle (capture_profiles.vehicle_id) else label-only from capture_profiles.vehicle text
   *
   * @generated from field: mono.projectdata.v1.EntityRef vehicle = 9;
   */ _define_property(this, "vehicle", void 0), /**
   * @generated from field: mono.projectdata.v1.PursuitHolder holder = 10;
   */ _define_property(this, "holder", void 0), /**
   * @generated from field: mono.projectdata.v1.PursuitOwner owner = 11;
   */ _define_property(this, "owner", void 0), /**
   * live capture_rfi_response_links (legacy rfi_events NOT counted)
   *
   * @generated from field: int32 rfi_response_count = 12;
   */ _define_property(this, "rfiResponseCount", 0), /**
   * live capture_proposal_links (deleted_at IS NULL)
   *
   * @generated from field: int32 proposal_count = 13;
   */ _define_property(this, "proposalCount", 0), /**
   * @generated from field: string opportunity_id = 14;
   */ _define_property(this, "opportunityId", ""), /**
   * RFC3339
   *
   * @generated from field: string updated_at = 15;
   */ _define_property(this, "updatedAt", ""), /**
   * RFC3339, newest activity; empty when none
   *
   * @generated from field: string last_activity_at = 16;
   */ _define_property(this, "lastActivityAt", ""), /**
   * "split from <name>" subtitle; empty when not split or unreadable
   *
   * @generated from field: string split_from_name = 17;
   */ _define_property(this, "splitFromName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitRow, "runtime", proto3);
_define_property(PursuitRow, "typeName", "mono.projectdata.v1.PursuitRow");
_define_property(PursuitRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "labels",
            kind: "message",
            T: PursuitLabel,
            repeated: true
        },
        {
            no: 7,
            name: "customer",
            kind: "message",
            T: EntityRef
        },
        {
            no: 8,
            name: "contracting_office",
            kind: "message",
            T: EntityRef
        },
        {
            no: 9,
            name: "vehicle",
            kind: "message",
            T: EntityRef
        },
        {
            no: 10,
            name: "holder",
            kind: "message",
            T: PursuitHolder
        },
        {
            no: 11,
            name: "owner",
            kind: "message",
            T: PursuitOwner
        },
        {
            no: 12,
            name: "rfi_response_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 13,
            name: "proposal_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 14,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "last_activity_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 17,
            name: "split_from_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListPursuitsResponse
 */ export class ListPursuitsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListPursuitsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListPursuitsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListPursuitsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListPursuitsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: string next_page_token = 2;
   */ _define_property(this, "nextPageToken", ""), /**
   * Counts over READABLE pursuits only (never hidden ones): keys live | parked | closed.
   *
   * @generated from field: map<string, int32> lifecycle_counts = 3;
   */ _define_property(this, "lifecycleCounts", {});
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListPursuitsResponse, "runtime", proto3);
_define_property(ListPursuitsResponse, "typeName", "mono.projectdata.v1.ListPursuitsResponse");
_define_property(ListPursuitsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: PursuitRow,
            repeated: true
        },
        {
            no: 2,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "lifecycle_counts",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 5 /* ScalarType.INT32 */ 
            }
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitHeaderRequest
 */ export class GetPursuitHeaderRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitHeaderRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitHeaderRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitHeaderRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitHeaderRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitHeaderRequest, "runtime", proto3);
_define_property(GetPursuitHeaderRequest, "typeName", "mono.projectdata.v1.GetPursuitHeaderRequest");
_define_property(GetPursuitHeaderRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitCapabilities
 */ export class PursuitCapabilities extends Message {
    static fromBinary(bytes, options) {
        return new PursuitCapabilities().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitCapabilities().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitCapabilities().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitCapabilities, a, b);
    }
    constructor(data){
        super(), /**
   * capture_project update
   *
   * @generated from field: bool can_edit = 1;
   */ _define_property(this, "canEdit", false), /**
   * capture_project view_sensitive
   *
   * @generated from field: bool can_view_sensitive = 2;
   */ _define_property(this, "canViewSensitive", false), /**
   * capture_project record_go_no_go
   *
   * @generated from field: bool can_record_go_no_go = 3;
   */ _define_property(this, "canRecordGoNoGo", false), /**
   * @generated from field: bool can_convert_to_proposal = 4;
   */ _define_property(this, "canConvertToProposal", false), /**
   * capture_project create @ tenant root (split needs it)
   *
   * @generated from field: bool can_create_pursuit = 5;
   */ _define_property(this, "canCreatePursuit", false), /**
   * v2.1 OD-19: = can_edit (capture_project update, not merged)
   *
   * @generated from field: bool can_set_growth_hint = 6;
   */ _define_property(this, "canSetGrowthHint", false), /**
   * GRW-36: FND-25 growth.event.write (tenant root)
   *
   * @generated from field: bool can_write_events = 7;
   */ _define_property(this, "canWriteEvents", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitCapabilities, "runtime", proto3);
_define_property(PursuitCapabilities, "typeName", "mono.projectdata.v1.PursuitCapabilities");
_define_property(PursuitCapabilities, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "can_edit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "can_view_sensitive",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "can_record_go_no_go",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 4,
            name: "can_convert_to_proposal",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "can_create_pursuit",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 6,
            name: "can_set_growth_hint",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 7,
            name: "can_write_events",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * The next scheduled go/no-go GATE = an open capture review with kind='gate' and no linked record
 * (GRW-05). Never a capture_go_no_go_decisions row (no UI creates those; V4).
 *
 * @generated from message mono.projectdata.v1.PursuitNextDecision
 */ export class PursuitNextDecision extends Message {
    static fromBinary(bytes, options) {
        return new PursuitNextDecision().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitNextDecision().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitNextDecision().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitNextDecision, a, b);
    }
    constructor(data){
        super(), /**
   * govcon.capture_reviews.id (kind='gate', status='open', go_no_go_record_id IS NULL)
   *
   * @generated from field: string review_id = 1;
   */ _define_property(this, "reviewId", ""), /**
   * capture_reviews.title, e.g. "Gate 2"
   *
   * @generated from field: string gate_label = 2;
   */ _define_property(this, "gateLabel", ""), /**
   * capture_reviews.review_date, YYYY-MM-DD (date only; no time exists)
   *
   * @generated from field: string due_at = 3;
   */ _define_property(this, "dueAt", ""), /**
   * capture_reviews.decider_user_id; empty when not set
   *
   * @generated from field: string decider_user_id = 4;
   */ _define_property(this, "deciderUserId", ""), /**
   * resolved in zou; empty when unset or unresolvable
   *
   * @generated from field: string decider_display_name = 5;
   */ _define_property(this, "deciderDisplayName", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitNextDecision, "runtime", proto3);
_define_property(PursuitNextDecision, "typeName", "mono.projectdata.v1.PursuitNextDecision");
_define_property(PursuitNextDecision, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "review_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "gate_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "due_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "decider_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "decider_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * RFI answering progress. ONLYOFFICE is the editor (V1): there is no "final" state GRW can read,
 * so GRW shows only what users mark: "{answered} of {total} marked answered".
 *
 * @generated from message mono.projectdata.v1.PursuitRfiProgress
 */ export class PursuitRfiProgress extends Message {
    static fromBinary(bytes, options) {
        return new PursuitRfiProgress().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitRfiProgress().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitRfiProgress().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitRfiProgress, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * rfi_response_projects.title, e.g. "RFI #2 · Transition and data"
   *
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * "RFI #2" when title matches ^RFI #\d+, else first 24 chars of title
   *
   * @generated from field: string short_label = 3;
   */ _define_property(this, "shortLabel", ""), /**
   * questions marked answered (source rule in GRW-12: pre-WRT rfi_questions, post-WRT §6 contract)
   *
   * @generated from field: int32 answered_count = 4;
   */ _define_property(this, "answeredCount", 0), /**
   * government questions (same source)
   *
   * @generated from field: int32 total_count = 5;
   */ _define_property(this, "totalCount", 0), /**
   * rfi_response_projects.response_due
   *
   * @generated from field: string due_at = 6;
   */ _define_property(this, "dueAt", ""), /**
   * /rfi-response/{rfi zou_project_id} (§3.2)
   *
   * @generated from field: string href = 7;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitRfiProgress, "runtime", proto3);
_define_property(PursuitRfiProgress, "typeName", "mono.projectdata.v1.PursuitRfiProgress");
_define_property(PursuitRfiProgress, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "short_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "answered_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "total_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "due_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitContractClock
 */ export class PursuitContractClock extends Message {
    static fromBinary(bytes, options) {
        return new PursuitContractClock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitContractClock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitContractClock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitContractClock, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string program_id = 1;
   */ _define_property(this, "programId", ""), /**
   * COALESCE(programs.program_name_short, programs.program_name_full)
   *
   * @generated from field: string program_label = 2;
   */ _define_property(this, "programLabel", ""), /**
   * programs.contract_number (+ "/" + task_number when present)
   *
   * @generated from field: string contract_number = 3;
   */ _define_property(this, "contractNumber", ""), /**
   * date YYYY-MM-DD: max end_date of exercised periods (else base)
   *
   * @generated from field: string current_period_end = 4;
   */ _define_property(this, "currentPeriodEnd", ""), /**
   * date: max end_date over ALL periods incl. unexercised options
   *
   * @generated from field: string ultimate_end = 5;
   */ _define_property(this, "ultimateEnd", ""), /**
   * periods_of_performance | program_pop_end | program_contract_end | opportunity_signal
   *
   * @generated from field: string source = 6;
   */ _define_property(this, "source", ""), /**
   * floor months from today (UTC); negative when past
   *
   * @generated from field: int32 months_to_ultimate_end = 7;
   */ _define_property(this, "monthsToUltimateEnd", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitContractClock, "runtime", proto3);
_define_property(PursuitContractClock, "typeName", "mono.projectdata.v1.PursuitContractClock");
_define_property(PursuitContractClock, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "program_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "contract_number",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "current_period_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "ultimate_end",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "months_to_ultimate_end",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitBlackHatRange
 */ export class PursuitBlackHatRange extends Message {
    static fromBinary(bytes, options) {
        return new PursuitBlackHatRange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitBlackHatRange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitBlackHatRange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitBlackHatRange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string participant_id = 1;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string company_name = 3;
   */ _define_property(this, "companyName", ""), /**
   * @generated from field: int64 low_cents = 4;
   */ _define_property(this, "lowCents", protoInt64.zero), /**
   * @generated from field: int64 high_cents = 5;
   */ _define_property(this, "highCents", protoInt64.zero), /**
   * 0 = not set on the scenarios
   *
   * @generated from field: int32 period_months = 6;
   */ _define_property(this, "periodMonths", 0), /**
   * @generated from field: int32 version = 7;
   */ _define_property(this, "version", 0), /**
   * RFC3339 of that version
   *
   * @generated from field: string created_at = 8;
   */ _define_property(this, "createdAt", ""), /**
   * low_high_roles | min_max_priced | none
   *
   * @generated from field: string basis = 9;
   */ _define_property(this, "basis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitBlackHatRange, "runtime", proto3);
_define_property(PursuitBlackHatRange, "typeName", "mono.projectdata.v1.PursuitBlackHatRange");
_define_property(PursuitBlackHatRange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "company_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "low_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 5,
            name: "high_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "period_months",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitPersonFact
 */ export class PursuitPersonFact extends Message {
    static fromBinary(bytes, options) {
        return new PursuitPersonFact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitPersonFact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitPersonFact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitPersonFact, a, b);
    }
    constructor(data){
        super(), /**
   * empty for unresolved stakeholders
   *
   * @generated from field: string contact_id = 1;
   */ _define_property(this, "contactId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * pursuit_stakeholders.pursuit_role
   *
   * @generated from field: string role = 3;
   */ _define_property(this, "role", ""), /**
   * @generated from field: int32 touchpoint_count = 4;
   */ _define_property(this, "touchpointCount", 0), /**
   * /registries/contacts/{id} when contact_id set
   *
   * @generated from field: string href = 5;
   */ _define_property(this, "href", ""), /**
   * v2.3 (GRW-12/37): resolved | candidate
   *
   * @generated from field: string resolution_state = 6;
   */ _define_property(this, "resolutionState", ""), /**
   * v2.3: REG-54 candidate id when resolution_state = candidate
   *
   * @generated from field: string registry_candidate_id = 7;
   */ _define_property(this, "registryCandidateId", ""), /**
   * v2.3: pursuit_stakeholders.id (GRW-37 ResolvePursuitEntity.link_id)
   *
   * @generated from field: string stakeholder_id = 8;
   */ _define_property(this, "stakeholderId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitPersonFact, "runtime", proto3);
_define_property(PursuitPersonFact, "typeName", "mono.projectdata.v1.PursuitPersonFact");
_define_property(PursuitPersonFact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "contact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "role",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "touchpoint_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "resolution_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "registry_candidate_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "stakeholder_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitCompetitorFact
 */ export class PursuitCompetitorFact extends Message {
    static fromBinary(bytes, options) {
        return new PursuitCompetitorFact().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitCompetitorFact().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitCompetitorFact().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitCompetitorFact, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string participant_id = 1;
   */ _define_property(this, "participantId", ""), /**
   * @generated from field: string company_profile_id = 2;
   */ _define_property(this, "companyProfileId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * "incumbent" | "likely prime" | "likely sub" | "possible prime" | "watching" (see GRW-12 rule)
   *
   * @generated from field: string stance_label = 4;
   */ _define_property(this, "stanceLabel", ""), /**
   * /registries/companies/{id}
   *
   * @generated from field: string href = 5;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitCompetitorFact, "runtime", proto3);
_define_property(PursuitCompetitorFact, "typeName", "mono.projectdata.v1.PursuitCompetitorFact");
_define_property(PursuitCompetitorFact, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "participant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "company_profile_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "stance_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitOpportunityFacts
 */ export class PursuitOpportunityFacts extends Message {
    static fromBinary(bytes, options) {
        return new PursuitOpportunityFacts().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitOpportunityFacts().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitOpportunityFacts().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitOpportunityFacts, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string opportunity_id = 1;
   */ _define_property(this, "opportunityId", ""), /**
   * @generated from field: mono.projectdata.v1.EntityRef customer = 2;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: mono.projectdata.v1.EntityRef contracting_office = 3;
   */ _define_property(this, "contractingOffice", void 0), /**
   * @generated from field: mono.projectdata.v1.EntityRef vehicle = 4;
   */ _define_property(this, "vehicle", void 0), /**
   * opportunity_values kind='deal', lot_id NULL; 0 + empty label when none
   *
   * @generated from field: int64 estimated_value_cents = 5;
   */ _define_property(this, "estimatedValueCents", protoInt64.zero), /**
   * "$120M"
   *
   * @generated from field: string estimated_value_label = 6;
   */ _define_property(this, "estimatedValueLabel", ""), /**
   * capture_profiles.procurement_type text
   *
   * @generated from field: string set_aside = 7;
   */ _define_property(this, "setAside", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string rfp_expected_on = 8;
   */ _define_property(this, "rfpExpectedOn", ""), /**
   * @generated from field: string rfp_expected_basis = 9;
   */ _define_property(this, "rfpExpectedBasis", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitOpportunityFacts, "runtime", proto3);
_define_property(PursuitOpportunityFacts, "typeName", "mono.projectdata.v1.PursuitOpportunityFacts");
_define_property(PursuitOpportunityFacts, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "opportunity_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "customer",
            kind: "message",
            T: EntityRef
        },
        {
            no: 3,
            name: "contracting_office",
            kind: "message",
            T: EntityRef
        },
        {
            no: 4,
            name: "vehicle",
            kind: "message",
            T: EntityRef
        },
        {
            no: 5,
            name: "estimated_value_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 6,
            name: "estimated_value_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "set_aside",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "rfp_expected_on",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "rfp_expected_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PursuitRelated
 */ export class PursuitRelated extends Message {
    static fromBinary(bytes, options) {
        return new PursuitRelated().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PursuitRelated().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PursuitRelated().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PursuitRelated, a, b);
    }
    constructor(data){
        super(), /**
   * split_from + split children (GRW-18); readable only
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef siblings = 1;
   */ _define_property(this, "siblings", []), /**
   * set on a merged stub
   *
   * @generated from field: mono.projectdata.v1.EntityRef merged_into = 2;
   */ _define_property(this, "mergedInto", void 0), /**
   * via opportunity membership (state 'active') and seat membership
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef landscapes = 3;
   */ _define_property(this, "landscapes", []), /**
   * recompete programs: label = contract_number; readable only
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef current_contracts = 4;
   */ _define_property(this, "currentContracts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PursuitRelated, "runtime", proto3);
_define_property(PursuitRelated, "typeName", "mono.projectdata.v1.PursuitRelated");
_define_property(PursuitRelated, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "siblings",
            kind: "message",
            T: EntityRef,
            repeated: true
        },
        {
            no: 2,
            name: "merged_into",
            kind: "message",
            T: EntityRef
        },
        {
            no: 3,
            name: "landscapes",
            kind: "message",
            T: EntityRef,
            repeated: true
        },
        {
            no: 4,
            name: "current_contracts",
            kind: "message",
            T: EntityRef,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetPursuitHeaderResponse
 */ export class GetPursuitHeaderResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetPursuitHeaderResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetPursuitHeaderResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetPursuitHeaderResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetPursuitHeaderResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * @generated from field: string name = 3;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string lifecycle = 4;
   */ _define_property(this, "lifecycle", ""), /**
   * @generated from field: string business_phase = 5;
   */ _define_property(this, "businessPhase", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitLabel labels = 6;
   */ _define_property(this, "labels", []), /**
   * "Recompete of our OMEGA contract · sibling: OMEGA Data Services"
   *
   * @generated from field: string context_line = 7;
   */ _define_property(this, "contextLine", ""), /**
   * @generated from field: mono.projectdata.v1.PursuitCapabilities capabilities = 8;
   */ _define_property(this, "capabilities", void 0), /**
   * unset when no open gate review (the common case for existing tenants)
   *
   * @generated from field: mono.projectdata.v1.PursuitNextDecision next_decision = 9;
   */ _define_property(this, "nextDecision", void 0), /**
   * unset when no open linked RFI response
   *
   * @generated from field: mono.projectdata.v1.PursuitRfiProgress rfi_progress = 10;
   */ _define_property(this, "rfiProgress", void 0), /**
   * unset when no readable recompete program and no opportunity signal
   *
   * @generated from field: mono.projectdata.v1.PursuitContractClock contract_clock = 11;
   */ _define_property(this, "contractClock", void 0), /**
   * unset when no black hat version exists
   *
   * @generated from field: mono.projectdata.v1.PursuitBlackHatRange black_hat = 12;
   */ _define_property(this, "blackHat", void 0), /**
   * @generated from field: mono.projectdata.v1.PursuitOwner owner = 13;
   */ _define_property(this, "owner", void 0), /**
   * capture_projects.created_at RFC3339
   *
   * @generated from field: string opened_at = 14;
   */ _define_property(this, "openedAt", ""), /**
   * at_award | from_opportunity | manual
   *
   * @generated from field: string opened_basis = 15;
   */ _define_property(this, "openedBasis", ""), /**
   * @generated from field: mono.projectdata.v1.PursuitOpportunityFacts opportunity = 16;
   */ _define_property(this, "opportunity", void 0), /**
   * max 8, ordered by touchpoint_count DESC, name
   *
   * @generated from field: repeated mono.projectdata.v1.PursuitPersonFact people = 17;
   */ _define_property(this, "people", []), /**
   * max 6
   *
   * @generated from field: repeated mono.projectdata.v1.PursuitCompetitorFact competitors = 18;
   */ _define_property(this, "competitors", []), /**
   * @generated from field: mono.projectdata.v1.PursuitRelated related = 19;
   */ _define_property(this, "related", void 0), /**
   * Sidebar counts are NOT here: FND-18 PursuitSidebar reads GetLinkedNodes.counts (GRW-10 keys).
   * v2.1 OD-19: capture_projects.show_growth_hint_to_delivery, returned to pursuit readers only;
   * drives the rail switch (GRW-04 GrowthHintControl, mounted by GRW-16).
   *
   * @generated from field: bool show_growth_hint_to_delivery = 20;
   */ _define_property(this, "showGrowthHintToDelivery", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetPursuitHeaderResponse, "runtime", proto3);
_define_property(GetPursuitHeaderResponse, "typeName", "mono.projectdata.v1.GetPursuitHeaderResponse");
_define_property(GetPursuitHeaderResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "lifecycle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "business_phase",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "labels",
            kind: "message",
            T: PursuitLabel,
            repeated: true
        },
        {
            no: 7,
            name: "context_line",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "capabilities",
            kind: "message",
            T: PursuitCapabilities
        },
        {
            no: 9,
            name: "next_decision",
            kind: "message",
            T: PursuitNextDecision
        },
        {
            no: 10,
            name: "rfi_progress",
            kind: "message",
            T: PursuitRfiProgress
        },
        {
            no: 11,
            name: "contract_clock",
            kind: "message",
            T: PursuitContractClock
        },
        {
            no: 12,
            name: "black_hat",
            kind: "message",
            T: PursuitBlackHatRange
        },
        {
            no: 13,
            name: "owner",
            kind: "message",
            T: PursuitOwner
        },
        {
            no: 14,
            name: "opened_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 15,
            name: "opened_basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "opportunity",
            kind: "message",
            T: PursuitOpportunityFacts
        },
        {
            no: 17,
            name: "people",
            kind: "message",
            T: PursuitPersonFact,
            repeated: true
        },
        {
            no: 18,
            name: "competitors",
            kind: "message",
            T: PursuitCompetitorFact,
            repeated: true
        },
        {
            no: 19,
            name: "related",
            kind: "message",
            T: PursuitRelated
        },
        {
            no: 20,
            name: "show_growth_hint_to_delivery",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListThreadRequest
 */ export class ListThreadRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListThreadRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListThreadRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListThreadRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListThreadRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * empty = all groups
   *
   * @generated from field: repeated mono.projectdata.v1.ThreadGroup groups = 2;
   */ _define_property(this, "groups", []), /**
   * default 50, max 200
   *
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * opaque keyset (occurred_at DESC, id DESC)
   *
   * @generated from field: string page_token = 4;
   */ _define_property(this, "pageToken", ""), /**
   * RFC3339; when set, only events with occurred_at > since (GRW-21)
   *
   * @generated from field: string since = 5;
   */ _define_property(this, "since", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListThreadRequest, "runtime", proto3);
_define_property(ListThreadRequest, "typeName", "mono.projectdata.v1.ListThreadRequest");
_define_property(ListThreadRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "groups",
            kind: "enum",
            T: proto3.getEnumType(ThreadGroup),
            repeated: true
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ThreadEvent
 */ export class ThreadEvent extends Message {
    static fromBinary(bytes, options) {
        return new ThreadEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ThreadEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ThreadEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ThreadEvent, a, b);
    }
    constructor(data){
        super(), /**
   * "<source_table>:<row id>[:<suffix>]" — stable across reads
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * see GRW-13 kind table
   *
   * @generated from field: string kind = 2;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: mono.projectdata.v1.ThreadGroup group = 3;
   */ _define_property(this, "group", 0), /**
   * RFC3339
   *
   * @generated from field: string occurred_at = 4;
   */ _define_property(this, "occurredAt", ""), /**
   * the source column the date came from
   *
   * @generated from field: string date_field = 5;
   */ _define_property(this, "dateField", ""), /**
   * pill text: "Touchpoint", "Black hat", "Hearsay", "RFI", ...
   *
   * @generated from field: string kind_label = 6;
   */ _define_property(this, "kindLabel", ""), /**
   * SpecraBadge variant for the pill
   *
   * @generated from field: string tone = 7;
   */ _define_property(this, "tone", ""), /**
   * @generated from field: string title = 8;
   */ _define_property(this, "title", ""), /**
   * empty when masked
   *
   * @generated from field: string body = 9;
   */ _define_property(this, "body", ""), /**
   * true when body withheld for lack of view_sensitive
   *
   * @generated from field: bool masked = 10;
   */ _define_property(this, "masked", false), /**
   * @generated from field: string actor_user_id = 11;
   */ _define_property(this, "actorUserId", ""), /**
   * @generated from field: string actor_display_name = 12;
   */ _define_property(this, "actorDisplayName", ""), /**
   * documented | hearsay | internal_assessment
   *
   * @generated from field: string fact_class = 13;
   */ _define_property(this, "factClass", ""), /**
   * readable neighbours only
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef links = 14;
   */ _define_property(this, "links", []), /**
   * @generated from field: string source_table = 15;
   */ _define_property(this, "sourceTable", ""), /**
   * @generated from field: string source_id = 16;
   */ _define_property(this, "sourceId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ThreadEvent, "runtime", proto3);
_define_property(ThreadEvent, "typeName", "mono.projectdata.v1.ThreadEvent");
_define_property(ThreadEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "group",
            kind: "enum",
            T: proto3.getEnumType(ThreadGroup)
        },
        {
            no: 4,
            name: "occurred_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "date_field",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "kind_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "tone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "body",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "masked",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 11,
            name: "actor_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "actor_display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "fact_class",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 14,
            name: "links",
            kind: "message",
            T: EntityRef,
            repeated: true
        },
        {
            no: 15,
            name: "source_table",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 16,
            name: "source_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListThreadResponse
 */ export class ListThreadResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListThreadResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListThreadResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListThreadResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListThreadResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.ThreadEvent events = 1;
   */ _define_property(this, "events", []), /**
   * @generated from field: string next_page_token = 2;
   */ _define_property(this, "nextPageToken", ""), /**
   * Sources that failed to load (never "hidden by authz"); UI shows SpecraInlineBanner tone="warning".
   *
   * @generated from field: repeated string unavailable_sources = 3;
   */ _define_property(this, "unavailableSources", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListThreadResponse, "runtime", proto3);
_define_property(ListThreadResponse, "typeName", "mono.projectdata.v1.ListThreadResponse");
_define_property(ListThreadResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "events",
            kind: "message",
            T: ThreadEvent,
            repeated: true
        },
        {
            no: 2,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "unavailable_sources",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
